import { bind } from 'bind-decorator';
import React from 'react';
import { colours } from '../../../../styles/colours';

interface IProps {
  input: React.RefObject<HTMLInputElement>;
  value: string;
}

class ClinicalTextLabel extends React.Component<IProps> {
  static style = { color: colours.lightBlue, fontSize: 16 };

  render() {
    return (
      <span style={ClinicalTextLabel.style} onClick={this.onClick}>
        {this.props.value}
      </span>
    );
  }

  @bind
  onClick() {
    const { current: input } = this.props.input;
    if (!!input) {
      input.focus();
    }
  }
}

export default ClinicalTextLabel;
